import { useEffect } from 'react';
import Header from '../components/Header';

export default function MercadosEmergentes() {
  useEffect(() => { document.title = 'Mercados Emergentes — Sttora'; }, []);
  return (
    <div className="page">
      <Header />
      <main style={{ maxWidth: '860px', padding: '4rem 3rem' }}>
        <p style={{ color: 'var(--text-soft)', fontFamily: 'Inter, sans-serif' }}>
          Mercados Emergentes Autorizados — contenido próximamente.
        </p>
      </main>
    </div>
  );
}
